export const PLAY_VIDEO = "PLAY_VIDEO";
export const PAUSE_VIDEO = "PAUSE_VIDEO";

export const playVideo = _ => ({
    type: PLAY_VIDEO
});

export const pauseVideo = _ => ({
    type: PAUSE_VIDEO
});